import { UserPlus, ShieldCheck, FileCheck, Sparkle, MessagesSquare } from "lucide-react";
import "./ChevronSteps.css";

export const CHEVRON_STEPS = [
  {
    key: "register",
    title: "Register",
    icon: UserPlus,
    lines: ["Create Profile", "Agree Terms & Conditions"],
    mobileLines: ["Create Profile", "Agree T&C"],
    background: "linear-gradient(180deg, #6F80F2 0%, #5566E0 100%)",
  },
  {
    key: "fbi-check",
    title: "FBI Check",
    icon: ShieldCheck,
    lines: ["Complete Your FBI Identity Match Security Check", "Upload FBI Report"],
    mobileLines: ["FBI ID Check", "Upload Report"],
    background: "linear-gradient(180deg, #FF9340 0%, #F47A22 100%)",
  },
  {
    key: "admin-approval",
    title: "Admin Approval",
    icon: FileCheck,
    lines: ["Admin Reviews & Approves FBI Report", "User Receives Verified Badge"],
    mobileLines: ["Admin Review", "Verified Badge"],
    background: "linear-gradient(180deg, #3CC89E 0%, #22AE86 100%)",
  },
  {
    key: "profile",
    title: "Profile",
    icon: Sparkle,
    lines: ["25 Questions for better matching", "Star Signs & Numerology Setup"],
    mobileLines: ["25 Questions", "Star Signs"],
    background: "linear-gradient(180deg, #2BB0F5 0%, #1596E3 100%)",
  },
  {
    key: "verified-users",
    title: "Verified Users",
    icon: MessagesSquare,
    lines: ["Start Browsing Profile", "Start Chatting"],
    mobileLines: ["Browse Profiles", "Start Chatting"],
    background: "linear-gradient(180deg, #B455F5 0%, #9B3BE8 100%)",
  },
];

/**
 * Row of 5 interlocking chevron steps.
 *
 * `marginTop` controls the vertical position relative to whatever sits above it.
 * A percentage resolves against the container *width*, so when the hero
 * background is scaled `100% auto`, a % value keeps the bar pinned to the same
 * spot in the photo at every screen width.
 *
 * `width` applies from 768px up (centred); below that the same row is
 * scaled down to the full screen width and shows the shorter `mobileLines`. Purely visual — no links or click handlers.
 */
export default function ChevronSteps({
  steps = CHEVRON_STEPS,
  width = "100%",
  marginTop = 0,
  marginBottom = 0,
  className = "",
}) {
  return (
    <div
      className={`cs-wrap relative z-10 mx-auto w-full md:w-[var(--cs-width)] ${className}`}
      style={{ "--cs-width": width, marginTop, marginBottom }}
    >
      <ol data-testid="chevron-steps" className="cs-row list-none">
        {steps.map(({ key, title, icon: Icon, lines, mobileLines = lines, background }, i) => (
          <li key={key} className="cs-item" data-testid={`chevron-step-${key}`}>
            {i > 0 && <span className="cs-divider" aria-hidden="true" />}
            <div className="cs-shape" style={{ background }}>
              <span className="cs-num" aria-hidden="true">{i + 1}</span>
              <Icon className="cs-icon" aria-hidden="true" />
              <div className="min-w-0">
                <div className="cs-title">{title}</div>
                <div className="cs-lines cs-lines--desktop">
                  {lines.map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </div>
                <div className="cs-lines cs-lines--mobile">
                  {mobileLines.map((line) => (
                    <span key={line}>{line}</span>
                  ))}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
